let url = {
    api: 'https://www.cstr.cn/openapi/v3/',
    // api: 'http://localhost:8000/'
}
export default url;